var map = {
	"./StaffLife1.jpeg": 7063,
	"./StaffLife2.jpeg": 4810,
	"./StaffLife3.jpeg": 7649,
	"./StaffLife4.jpeg": 2292,
	"./StaffLife5.jpeg": 9323,
	"./StaffLife6.jpeg": 9054,
	"./StaffLife7.jpeg": 7365,
	"./StaffLife8.jpeg": 5352,
	"./StaffLife9.jpeg": 3871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8524;